export default {
  SET_AUTHENTICATION_MODES(state, authenticationsModes) {
    state.authenticationsModes = {
      hasAuthBySafea : authenticationsModes.hasAuthBySafea || false,
      hasAuthByEmail : authenticationsModes.hasAuthByEmail || false,
      hasAuthBySaml  : authenticationsModes.hasAuthBySaml || false,
      samlRequest    : authenticationsModes.samlRequest || null
    };
  },
  SET_OWNER(state, owner) {
    state.owner = owner;
  },
  SET_FEATURES(state, feature) {
    state.feature = feature;
  },
  SET_CREATE_ACCOUNT(state, createAccountEnabled) {
    state.createAccountEnabled = createAccountEnabled;
  },
  SET_IS_MOBILE(state) {
    state.isMobile = true;
  },
  SET_LOGO(state, theme) {
    state.logo = {
      light : theme.logo || require('@/assets/_core/img/logo-light.svg'),
      dark  : theme.darkLogo || require('@/assets/_core/img/logo-dark.svg')
    };
  },
  SET_LOGIN_PAGE_IMAGE(state, theme) {
    state.loginPageImage = theme.loginPageImage || require('@/assets/_core/img/login_page_image.png');
  },
  SET_CAPTCHA_KEY(state, key) {
    state.captchaKey = key;
  },
  SET_THEMES(state, theme) {
    const themeColorsLight = {
      primary : theme.primaryColor || process.env.DEFAULT_PRIMARY_COLOR,
      accent  : theme.accentColor || process.env.DEFAULT_ACCENT_COLOR
    };

    if (theme.secondaryColor || process.env.DEFAULT_SECONDARY_COLOR) {
      themeColorsLight.secondary = theme.secondaryColor || process.env.DEFAULT_SECONDARY_COLOR;
    }

    state.webThemeIsDark    = false;
    state.mobileThemeIsDark = false;

    state.themes = {
      favicon      : theme.favicon || `${process.env.APPLICATION_ROUTE_BASE}/favicon.ico`,
      loadingColor : theme.loadingColor || process.env.DEFAULT_PRIMARY_COLOR,
      light        : themeColorsLight
    };

    // Fix first load, set theme on vue client
    this.app.vuetify.framework.theme.themes.dark = {
      ...this.app.vuetify.preset.theme.themes.dark
    };
    this.app.vuetify.framework.theme.themes.light = {
      ...this.app.vuetify.preset.theme.themes.light,
      ...themeColorsLight
    };
  },
  REFRESH_THEME(state, darkThemeEnabled = false) {
    const themeColorsLight = {
      primary   : state.themes.light.primary,
      secondary : state.themes.light.secondary,
      accent    : state.themes.light.accent
    };

    this.app.vuetify.framework.theme.dark = process.env.DARK_MODE_ENABLED ? darkThemeEnabled : false;

    // Fix first load, set theme on vue client
    this.app.vuetify.framework.theme.themes.dark = {
      ...this.app.vuetify.preset.theme.themes.dark
    };
    this.app.vuetify.framework.theme.themes.light = {
      ...this.app.vuetify.preset.theme.themes.light,
      ...themeColorsLight
    };
  },
  SET_IS_OPERATION(state, value) {
    state.isOperation = value;
  },
  SET_SIDEBAR_DRAWER(state, payload) {
    state.sidebarDrawer = payload;
  },
  SET_HEADER_HEIGHT(state, height) {
    state.headerHeight = height;
  },
  SET_STATUS_MINI(state, payload) {
    state.statusMini = payload;
  },
  // TODO: After everyone makes use of the correct version of the layout, this can be removed
  PREPARE_LAYOUT_V2(state, payload) {
    state.prepareLayoutv2 = payload;
  },
  SET_LAYOUT_V2(state, payload) {
    state.layoutv2 = payload;
  }
};
